import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type MoneyExchangerInterface from "@modules/money/MoneyExchanger/MoneyExchangerInterface";
import type { InjectionToken } from "tsyringe";

import { createModalToken } from "@components/Modal/ModalManager";
import type { LoggerInterface } from "@interfaces/LoggerInterface";

import type { ModalParams, RefundModalParams } from "./utils/modal/types";

export const rewardsApplicationLoggerToken = Symbol(
    "rewardsApplicationLoggerToken"
) as InjectionToken<LoggerInterface>;

export const rewardsAuthApiClientToken = Symbol(
    "rewardsAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const rewardsAuthApiClientV3Token = Symbol(
    "rewardsAuthApiClientV3Token"
) as InjectionToken<ApiClientInterface>;

export const rewardsMoneyExchangerToken = Symbol(
    "rewardsMoneyExchangerToken"
) as InjectionToken<MoneyExchangerInterface>;

export const rewardsVerifyAccountModalWidgetToken = createModalToken(
    "RewardsVerifyAccountModalWidget"
);

export const rewardsJoinNowModalWidgetToken = createModalToken(
    "RewardsJoinNowModalWidget"
);

export const rewardsQrCodeModalWidgetToken = createModalToken(
    "RewardsQrCodeModalWidget"
);

export const rewardsWaysToEarnPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsWaysToEarnPageWidgetModal");

export const rewardsWaysToSpendPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsWaysToSpendPageWidgetModal");

export const rewardsAvailableRewardsPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsAvailableRewardsPageWidgetModal");

export const rewardsRefundDiscountModalWidgetToken =
    createModalToken<RefundModalParams>("RewardsRefundDiscountModalWidget");
